/** Ключі кешу TanStack Query. Префікси потрібні для точкової інвалідації з потоку подій. */
export const qk = {
  me: ['me'] as const,
  authConfig: ['auth-config'] as const,
  users: ['users'] as const,
  departments: ['departments'] as const,
  teams: ['teams'] as const,
  businessRoles: ['business-roles'] as const,
  accessPolicy: ['access-policy'] as const,
  projects: (includeArchived = false) => ['projects', { includeArchived }] as const,
  projectsAll: ['projects'] as const,
  project: (id: string) => ['project', id] as const,
  projectTemplates: ['project-templates'] as const,
  customFields: ['custom-fields'] as const,
  tags: ['tags'] as const,
  tasksAll: ['tasks'] as const,
  tasks: (params: Record<string, unknown>) => ['tasks', params] as const,
  task: (id: string) => ['task', id] as const,
  taskPart: (id: string, part: 'comments' | 'activity' | 'attachments' | 'subtasks') => ['task', id, part] as const,
  mySummary: ['my-summary'] as const,
  inboxAll: ['inbox'] as const,
  inbox: (params: Record<string, unknown>) => ['inbox', params] as const,
  search: (q: string) => ['search', q] as const,
  tokens: ['tokens'] as const,
  webhooks: ['webhooks'] as const,
  deliveries: (id: string) => ['webhooks', id, 'deliveries'] as const,
  scopes: ['meta', 'scopes'] as const,
  eventTypes: ['meta', 'event-types'] as const,
};
